import { PaymentLine } from './payment-line'

class PaymentItemSpecification {
  payments: PaymentLine[]
}

const buildPaymentItemConfiguration = function (): PaymentItemSpecification {
  return {
    payments: []
  }
}

export {
  PaymentItemSpecification,
  buildPaymentItemConfiguration
}



// WEBPACK FOOTER //
// ./src/types/payment-item-configuration.js